export const getLanguageDisplayName = (lang: string): string => {
  const map: Record<string, string> = {
    js: "JavaScript",
    ts: "TypeScript",
    jsx: "JSX",
    tsx: "TSX",
    html: "HTML",
    xml: "XML",
    css: "CSS",
    scss: "SCSS",
    sass: "Sass",
    json: "JSON",
    md: "Markdown",
    markdown: "Markdown",
    bash: "Bash",
    sh: "Shell",
    shell: "Shell",
    py: "Python",
    python: "Python",
    java: "Java",
    cpp: "C++",
    c: "C",
    cs: "C#",
    csharp: "C#",
    go: "Go",
    rust: "Rust",
    rb: "Ruby",
    ruby: "Ruby",
    php: "PHP",
    sql: "SQL",
    yaml: "YAML",
    yml: "YAML",
    toml: "TOML",
    dockerfile: "Dockerfile",
    diff: "Diff",
    text: "Text",
    plaintext: "Plain Text",
  };

  return (
    map[lang.toLowerCase()] || lang.charAt(0).toUpperCase() + lang.slice(1)
  );
};
